import { render, staticRenderFns } from "./selesai-hoc.vue?vue&type=template&id=12da280a&"
import script from "./selesai-hoc.vue?vue&type=script&lang=js&"
export * from "./selesai-hoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports